import { LocalStorageService as t } from "./LocalStorageService.mjs";
import { isNotNil as r } from "./types3.mjs";
const s = (o, e) => {
  t.setValue(o, JSON.stringify(e));
}, c = (o) => {
  const e = t.getValue(o);
  return r(e) ? JSON.parse(e) : null;
};
export {
  c as getLocalStorageValue,
  s as setLocalStorageValue
};
//# sourceMappingURL=utils5.mjs.map
